/** Socket.IO server base URL (no namespace path). */
export function getSocketUrl() {
  const fromEnv = process.env.REACT_APP_SOCKET_URL;
  if (fromEnv) return fromEnv.replace(/\/$/, '');

  const api = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';
  return api.replace(/\/api\/v1\/?$/, '') || 'http://localhost:5001';
}
